var fails = require('./_fails');

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_strict-method.js
 **/